<template lang="pug">
.container
  TimeBlock.time-block
  .login
    .login-img
    .login-box
      h2.greeting 桥梁除湿监测管理系统
      .login-content
        .system-name 用户登录
        input(type="text", name="username", placeholder="Username", v-model="username")
        input(type="password", name="password", placeholder="Password", v-model="password", @keyup.enter="login")
        button.login-submit(@click="login") LOGIN
      //- .company 中交公路规划设计院有限公司
</template>
<script>
import { loginAesSecret } from "./../../constants";
import { aesEncrypt, generateLocalAesIv } from "./../../tools/AesTool";

export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      iv: "",
    };
  },
  mounted() {
    this.getRemoteAesIv();
  },
  methods: {
    getRemoteAesIv() {
      this.$http.get("/auth/LoginAesIv").then((res) => {
        if (res.data.iv) {
          this.iv = res.data.iv;
        }
      });
    },
    login() {
      if (this.username.length === 0 || this.password.length === 0) {
        this.$message.error("请填写用户名与密码");
        return;
      }

      if (!this.iv || this.iv === "") {
        this.iv = generateLocalAesIv();
        console.log("local iv " + this.iv);
      }

      let aesIv = this.iv;
      this.iv = "";
      this.getRemoteAesIv();

      let encryptedPassword = aesEncrypt(this.password, loginAesSecret, aesIv);

      const data = {
        userId: this.username,
        password: encryptedPassword,
        iv: aesIv,
      };
      this.$http.post("/auth/Login", data).then((res) => {
        this.$router.push("/qingShuiIndex");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  height: 100%;
  background: url("../../assets/image/qingshui/qingshui1.png") no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .time-block {
    position: absolute;
    top: 100px;
    right: 150px;
  }

  .login {
    width: 865px;
    height: 496px;
    background: #fff;
    z-index: 100;

    &-img,
    &-box {
      float: left;
    }

    &-img {
      width: 285px;
      height: 100%;
      background: url("../../assets/image/qingshui/qingshui.jpg") 50% 50% no-repeat;
      background-size: cover;
    }

    &-box {
      width: 580px;
      height: 100%;
      color: #c4c4c4;
      padding: 0 40px;
      box-sizing: border-box;

      .company {
        margin: 8px 0 0 0;
        text-align: center;
        font-weight: 300;
      }

      .greeting {
        color: #000;
        margin: 70px 0;
        font-size: 30px;
        font-weight: 300;
      }

      .login-content {
        position: relative;
        height: 260px;
        border-bottom: 1px solid #ebebeb;

        .system-name {
          font-size: 18px;
          font-weight: 300;
        }

        & > input {
          outline: none;
          border: 0px;
          width: 100%;
          height: 50px;
          line-height: 30px;
          font-size: 20px;
          padding: 0 0 0 15px;
          margin: 10px 0;
          background: #ebebeb;
          box-sizing: border-box;
        }

        .login-submit {
          position: absolute;
          bottom: 40px;
          right: 0;
          height: 40px;
          width: 160px;
          color: #fff;
          background: #4486ff;
          border: none;
          cursor: pointer;
          font-weight: 300;

          &:hover {
            background: #306cd3;
          }
        }
      }
    }
  }

  input::-webkit-input-placeholder {
    font-weight: 300;
  }
}
</style>
